import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import Selector from 'react-select';
import { FaSearch } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

export default function FiltroCorretor({ onBuscar }) {
  const [corretores, setCorretores] = useState([]);
  const [selecionado, setSelecionado] = useState(null);
  const [isLoadingLista, setIsLoadingLista] = useState(true);

  useEffect(() => {
    const carregar = async () => {
      try {
        const resp = await api.buscarCorretoresSaldos();
        setCorretores(resp || []);
      } catch {
        // silencioso
      } finally {
        setIsLoadingLista(false);
      }
    };
    carregar();
  }, []);

  const options = (corretores || []).map(c => ({
    value: c.codigo,
    label: c.descricao,
  }));

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Row className="align-items-end">
          <Col xs={12} md={5}>
            <Form.Label>Corretor:</Form.Label>
            <Selector
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={options}
              isClearable
              isLoading={isLoadingLista}
              placeholder="Selecione um corretor..."
              value={selecionado}
              onChange={opt => setSelecionado(opt || null)}
              noOptionsMessage={() => 'Nenhum corretor encontrado'}
            />
          </Col>
          <Col xs={12} md={2}>
            <Button
              variant="success"
              block
              disabled={!selecionado}
              onClick={() => onBuscar(selecionado.value)}
            >
              <FaSearch /> Buscar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
